import { render } from "./ArticleSlideSelection.vue?vue&type=template&id=61a6665d&ts=true"
import script from "./ArticleSlideSelection.vue?vue&type=script&lang=ts"
export * from "./ArticleSlideSelection.vue?vue&type=script&lang=ts"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__